import Draft, { EditorState } from 'draft-js';
import { MutableRefObject, useMemo } from 'react';
import * as Models from 'models';
import * as editorUtils from 'utils/editor';

type Options = {
  colors: Models.BrandColorsList;
  fonts: Models.BrandFontsList;
};

export function useCustomStyleFn(
  options: Options,
  editorState: MutableRefObject<EditorState>,
): ((styles: Draft.DraftInlineStyle) => Models.CSSInlineStyle) {
  const { colors, fonts } = options;

  return useMemo(
    () => editorUtils.getCustomInlineStyle(colors, fonts, editorState),
    [colors, fonts],
  );
}
